import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ICService } from 'src/app/Service/IC/IC.service';
import { IC_Template } from 'src/app/Interface/IC_Interface';

@Component({
  selector: 'app-ic-template-list',
  templateUrl: './ICTemplateList.component.html',
  styleUrls: ['./ICTemplateList.component.css']
})
export class ICTemplateListComponent implements OnInit {
  items: IC_Template[] = [];
  search = '';
  status: boolean | undefined = true;
  loading = false;
  page = 1;

  constructor(private service: ICService, private router: Router, private alert: AlertifyService) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.page = 1;
    this.loading = true;
    this.service.getTemplates(this.search, this.status)
      .pipe(finalize(() => this.loading = false))
      .subscribe({ next: rows => this.items = rows || [], error: () => this.alert.ErrorMessage('دریافت فهرست قالب‌ها ناموفق بود.') });
  }

  add(): void { this.router.navigate(['/ic/template/add']); }
  edit(id: number): void { this.router.navigate(['/ic/template/edit', id]); }
  version(id: number): void {
    this.service.createTemplateVersion(id).subscribe({
      next: x => { this.alert.SuccessMessage('نسخه جدید ایجاد شد'); this.router.navigate(['/ic/template/edit', x.id]); },
      error: e => this.alert.ErrorMessage(e?.error?.message || 'ایجاد نسخه جدید با خطا مواجه شد')
    });
  }
}
